import { Component, OnInit, inject } from '@angular/core';
import {UntypedFormControl, Validators} from '@angular/forms';
import {
  AuthSandbox, ButtonConfig, buttonsStaticConfig,
  inputErrorTypes,
  NavigationService,
  NotificationEnum,
  NotificationService, RoutesEnum
} from '../../../modules/global';
import {ActivatedRoute} from '@angular/router';
import { ExternalPageContainerComponent } from '../../components/externap-page-container/external-page-container.component';
import { TranslateDirective } from '@ngx-translate/core';
import { TextInputComponent } from '../../../modules/shared/components/inputs/text-input/text-input.component';
import { ButtonComponent } from '../../../modules/shared/components/buttons/button/button.component';

@Component({
    selector: 'slm-reset-password',
    template: `
    <slm-external-page-container>
      <h4 translate="AUTHENTICATION.RESET.TITLE"></h4>
      <h5 translate="AUTHENTICATION.RESET.DESCRIPTION"></h5>
      <slm-text-input
        type="email"
        class="w-100 mt-3"
        label="LBL_INPUT.LABEL.EMAIL"
        [control]="emailControl"
        [errors]="errors"
      ></slm-text-input>
      <slm-button
        class="w-100 mt-2"
        (click)="resetPassword()"
        [loading]="btnLoading"
        type="submit"
        testId="sendEmail"
        text="AUTHENTICATION.RESET.SEND_EMAIL"
        [disabled]="emailControl.invalid"
      ></slm-button>
      <slm-button
        class="w-100 mt-2"
        [config]="goBackButton"
        testId="backButton"
      ></slm-button>
    </slm-external-page-container>
  `,
    imports: [ExternalPageContainerComponent, TranslateDirective, TextInputComponent, ButtonComponent]
})
export class ResetPasswordContainer implements OnInit {
  private readonly authSandbox = inject(AuthSandbox);
  private readonly route = inject(ActivatedRoute);
  private readonly navigation = inject(NavigationService);
  private readonly notification = inject(NotificationService);

  public readonly emailControl = new UntypedFormControl('', [Validators.required, Validators.email]);
  public readonly errors = [inputErrorTypes.email, inputErrorTypes.required];
  public btnLoading = false;
  public readonly goBackButton: ButtonConfig = {
    ...buttonsStaticConfig.back,
    url: `/${RoutesEnum.LOGIN}`
  };

  ngOnInit() {
    if (this.route.snapshot.queryParams.email) {
      this.emailControl.setValue(this.route.snapshot.queryParams.email);
    }
  }

  public resetPassword() {
    if (this.emailControl.invalid) {
      this.emailControl.markAllAsTouched();
      return;
    }
    if (this.btnLoading) {
      return;
    }
    this.btnLoading = true;
    this.authSandbox.resetPassword(this.emailControl.value).subscribe({
      next: () => {
        this.btnLoading = false;
        this.notification.notify('AUTHENTICATION.RESET.EMAIL_SENT', NotificationEnum.SUCCESS, 10000);
        this.navigation.navigate([RoutesEnum.LOGIN]);
      },
      error: () => this.btnLoading = false
    });
  }
}
